"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyExperimentRegisterResponseToJSON = exports.CopyExperimentRegisterResponseFromJSONTyped = exports.CopyExperimentRegisterResponseFromJSON = exports.instanceOfCopyExperimentRegisterResponse = void 0;
var runtime_1 = require("../runtime");
var CopyExperimentPayload_1 = require("./CopyExperimentPayload");
/**
 * Check if a given object implements the CopyExperimentRegisterResponse interface.
 */
function instanceOfCopyExperimentRegisterResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCopyExperimentRegisterResponse = instanceOfCopyExperimentRegisterResponse;
function CopyExperimentRegisterResponseFromJSON(json) {
    return CopyExperimentRegisterResponseFromJSONTyped(json, false);
}
exports.CopyExperimentRegisterResponseFromJSON = CopyExperimentRegisterResponseFromJSON;
function CopyExperimentRegisterResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'payload': !(0, runtime_1.exists)(json, 'payload') ? undefined : (0, CopyExperimentPayload_1.CopyExperimentPayloadFromJSON)(json['payload']),
        'signedUrl': !(0, runtime_1.exists)(json, 'signed_url') ? undefined : json['signed_url'],
    };
}
exports.CopyExperimentRegisterResponseFromJSONTyped = CopyExperimentRegisterResponseFromJSONTyped;
function CopyExperimentRegisterResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'payload': (0, CopyExperimentPayload_1.CopyExperimentPayloadToJSON)(value.payload),
        'signed_url': value.signedUrl,
    };
}
exports.CopyExperimentRegisterResponseToJSON = CopyExperimentRegisterResponseToJSON;
